import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AppHeader = ({ userName = 'User' }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <div className="app-header">
        <div className="app-header-content">
          <div className="app-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_credit-gps-demo/artifacts/sc61wlvn_IMG_3537.jpeg" 
              alt="Credit GPS"
              width="32"
              height="32"
              style={{ borderRadius: '50%' }}
              className="logo-image"
            />
            <span className="logo-text">Credit GPS</span>
          </div>
          
          <div className="app-header-actions">
            <button className="notification-btn" data-testid="notification-btn">
              <span className="notification-icon">🔔</span>
            </button>
            <button 
              className="profile-btn" 
              data-testid="profile-btn"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <span className="profile-avatar">{userName.charAt(0).toUpperCase()}</span>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="menu-overlay" onClick={() => setMenuOpen(false)}>
          <div className="menu-drawer" onClick={(e) => e.stopPropagation()}>
            <div className="menu-header">
              <div className="menu-profile">
                <div className="menu-avatar">{userName.charAt(0).toUpperCase()}</div>
                <div>
                  <div className="menu-name">{userName}</div>
                  <div className="menu-email">member@creditgps.com</div>
                </div>
              </div>
            </div>
            
            <div className="menu-items">
              <button className="menu-item" onClick={() => { setMenuOpen(false); }}>
                <span className="menu-icon">📋</span>
                <span>Action Plan</span>
              </button>
              <button className="menu-item" onClick={() => { setMenuOpen(false); }}>
                <span className="menu-icon">📊</span>
                <span>Progress</span>
              </button>
              <button className="menu-item" onClick={() => { setMenuOpen(false); }}>
                <span className="menu-icon">📚</span>
                <span>Resources</span>
              </button>
              <div className="menu-divider"></div>
              <button className="menu-item">
                <span className="menu-icon">⚙️</span>
                <span>Settings</span>
              </button>
              <button className="menu-item" onClick={() => navigate('/')}>
                <span className="menu-icon">🚪</span>
                <span>Exit Dashboard</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AppHeader;
